import React from "react";
import { Button } from "../button/Button";
import { ButtonSize, ButtonVariant } from "../button/Shared";
import { DeleteConfirmationModal } from "./DeleteConfirmationModal";

type DeleteConfirmationButtonProps = {
    asIcon?: boolean,
    title?: string,
    buttonText: string,
    buttonSize?:ButtonSize,
    tooltipText?: string,
    tooltipHorizontalAlignment?: 'left' | 'right',
    confirmationHeading: string,
    confirmationText: string,
    requireKey: boolean,
    hideIcon?: boolean,
    onConfirmDelete: () => void,
    disabled?:boolean,
    fullWidth?:boolean,
    variant?: ButtonVariant
}
export function DeleteConfirmationButton(props: DeleteConfirmationButtonProps): JSX.Element {
    const [showModal, setShowModal] = React.useState(false);

    function handleClickButton() {
        setShowModal(true); 
    }

    function handleConfirmClick() {
        props.onConfirmDelete();
        setShowModal(false);
    }

    return (
        <>
            {props.asIcon 
                ?
                <Button
                    toolTipText={props.tooltipText}
                    tooltipHorizontalAlignment={props.tooltipHorizontalAlignment}
                    variant={props.variant ? props.variant : "destructive"}
                    size={props.buttonSize || "42px"}
                    onClick={() => handleClickButton()}
                    icon={"interface_actions_delete"}
                    disabled={props.disabled} />
                :
                <Button
                    toolTipText={props.tooltipText}
                    tooltipHorizontalAlignment={props.tooltipHorizontalAlignment}
                    variant={props.variant ? props.variant : "destructive"}
                    onClick={() => handleClickButton()}
                    icon={props.hideIcon ? undefined : "interface_actions_delete"}
                    text={props.buttonText}
                    size={props.buttonSize || "42px"}
                    disabled={props.disabled} />
            }

            <DeleteConfirmationModal 
                showModal={showModal} 
                {...props}
                onCancel={() => setShowModal(false)}
                onConfirmDelete={handleConfirmClick} />

        </>
    )
}